import NewSalesInvoice from "../../../../components/@documents/sales_invoices/NewSalesInvoice";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function SalesInvoiceNewPage() {

    return (
        <NewSalesInvoice 
            routeType={routeTypes.admin}
        />
    )
}